import type { RydeUiUnit } from "@ryde/shared";

/** The place-info mode every map offers: a click asks the company's geocoder what is at that point. */
export const MAPLIBRE_PLACE_INFO = {
  /**
   * How far the pointer may move between press and release and still be a click. MapLibre's own
   * `clickTolerance` default, so the press that pans the map never opens a popup.
   */
  clickTolerancePx: 3,
  /** Decimal places a clicked point is shown with; the fifth is about a metre. */
  coordinateFractionDigits: 5,
  /** Lifts the popup's tail clear of the clicked-point dot. */
  popupOffsetPx: 12,
  /** The card sets its own width; MapLibre's default cap would squeeze it. */
  popupMaxWidth: "none",
} as const;

/** Where the lookup for the clicked point stands. */
export const MAPLIBRE_PLACE_INFO_STATUS = {
  Loading: "Loading",
  Found: "Found",
  /** The provider answered and has no address there (at sea, say). */
  Empty: "Empty",
  Failed: "Failed",
} as const;

/** What "Add station here" creates. */
export const MAPLIBRE_PLACE_INFO_STATION_ENTITY: RydeUiUnit = "station";
